import dynamic from "next/dynamic";

const FloatVideo = dynamic(() => import("./FloatVideo"), {
	loading: () => <p>Ładowanie wideo...</p>,
});

const DeclarationBoxIndividual = dynamic(() => import("./DeclarationBoxIndividual"), {
	loading: () => <p>Ładowanie deklaracji...</p>,
});

const DeclarationModal = dynamic(() => import("./DeclarationModal"), {
	loading: () => <p>Ładowanie modal...</p>,
});

export { FloatVideo, DeclarationBoxIndividual, DeclarationModal };
